webpackJsonp([1520471504850],{

/***/ 392:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 286:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.trainingQuery = undefined;
	exports.default = Index;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMailto = __webpack_require__(78);
	
	var _reactMailto2 = _interopRequireDefault(_reactMailto);
	
	var _gatsbyLink = __webpack_require__(18);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(392);
	
	var _typography = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line react/prop-types
	function Index(_ref) {
		var data = _ref.data;
		var email = data.site.siteMetadata.email;
	
	
		return _react2.default.createElement(
			"main",
			{ className: "container container-page training" },
			_react2.default.createElement(
				"h1",
				{ style: { marginBottom: (0, _typography.rhythm)(1) } },
				"Training Workshops"
			),
			_react2.default.createElement(
				"p",
				{ style: { marginBottom: (0, _typography.rhythm)(2) } },
				"Please ",
				_react2.default.createElement(
					_reactMailto2.default,
					{ email: email },
					"get in touch"
				),
				" to book the following in-person training workshops for your organisation."
			),
			_react2.default.createElement(
				"h2",
				{ style: { marginBottom: (0, _typography.rhythm)(0.5) } },
				_react2.default.createElement(
					_gatsbyLink2.default,
					{ to: "/training/full-stack-serverless-graphql-appsync" },
					"Building Full Stack Serverless GraphQL Apps on AWS Appsync"
				)
			),
			_react2.default.createElement(
				"p",
				null,
				"In this course you will learn the best way to build and deploy a production grade app that uses a GraphQL API built on Appsync. In the process, you will be guided through best practices for building your API using AWS",
				"'",
				"s integrated services for data storage, authentication and receiving real time updates."
			),
			_react2.default.createElement(
				"h2",
				{ style: { marginBottom: (0, _typography.rhythm)(0.5) } },
				_react2.default.createElement(
					_gatsbyLink2.default,
					{ to: "/training/introduction-to-serverless-on-aws" },
					"Introduction to Serverless on AWS Lambda"
				)
			),
			_react2.default.createElement(
				"p",
				null,
				"The workshop is designed for those beginning serverless. It is hands on, practical focused. Partipants are guided through the process of building and deploying a serverless API backed by a multi-region database using DynamoDB, AWS Lambda, API Gateway and Route53."
			)
		);
	}
	
	var trainingQuery = exports.trainingQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-training-js-bbca9bbaa7f64490437c.js